import { useCallback, useState } from 'react';

const STORAGE_KEY = 'xdocs.documents-hint-dismissed';

function loadDismissed(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function saveDismissed(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // best-effort — the hint just reappears next session without persistence.
  }
}

/**
 * Persisted dismiss state for the `⌘K` tip banner on `/documents`
 * (design/app/18-documents.html `showDocHint`/`dismissDocHint`) — local-only,
 * mirrors `useReaderPrefs`'s localStorage pattern (no server round-trip for a
 * purely cosmetic first-run hint).
 */
export function useDocHint(): { showDocHint: boolean; dismissDocHint: () => void } {
  const [dismissed, setDismissed] = useState(loadDismissed);

  const dismissDocHint = useCallback(() => {
    saveDismissed();
    setDismissed(true);
  }, []);

  return { showDocHint: !dismissed, dismissDocHint };
}
